import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminSuppliesUploadPage } from './admin-supplies-upload';

@NgModule({
  declarations: [
    AdminSuppliesUploadPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminSuppliesUploadPage),
  ],
})
export class AdminSuppliesUploadPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-supplies-upload/admin-supplies-upload.module.ts